// SPDX-FileCopyrightText: 2022 Genome Research Ltd.
//
// SPDX-License-Identifier: MIT
import { createContext, useContext } from 'react';
export var AuthContext = createContext({
    token: '',
    setToken: function () {
        throw new Error('Missing AuthContext Provider');
    },
    user: null,
    setUser: function () {
        throw new Error('Missing AuthContext Provider');
    },
});
export var AuthProvider = AuthContext.Provider;
export var useAuth = function () { return useContext(AuthContext); };
